import { defineComponent, resolveDirective, createElementBlock, openBlock, Fragment, renderList, withDirectives, normalizeClass, createVNode, withCtx, renderSlot, createTextVNode, toDisplayString } from "vue";
import { _ as _sfc_main$1 } from "./p-btn.js";
const _hoisted_1 = { class: "flex" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PSelectBtn"
  },
  __name: "p-select-btn",
  props: {
    modelValue: { default: null },
    items: { default: () => [] },
    itemValue: { default: "value" },
    itemText: { default: "text" },
    itemTooltipText: { default: "text" },
    size: { default: "md" },
    showTooltip: { type: Boolean, default: false },
    highlightSelected: { type: Boolean, default: true },
    grow: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const tooltipText = (item) => {
      return props.showTooltip ? item[props.itemTooltipText] : "";
    };
    const select = (item) => {
      if (!props.multiple) {
        emit("update:modelValue", item[props.itemValue]);
      } else {
        if (Array.isArray(props.modelValue)) {
          const val = item[props.itemValue];
          const index = props.modelValue.findIndex((i) => i[props.itemValue] === val);
          if (index !== -1) {
            emit(
              "update:modelValue",
              props.modelValue.filter((i) => i[props.itemValue] !== val)
            );
          } else {
            emit("update:modelValue", [...props.modelValue, item]);
          }
        } else {
          emit("update:modelValue", [item]);
        }
      }
    };
    const isSelected = (item) => {
      if (!props.multiple) {
        return props.modelValue === item[props.itemValue];
      } else {
        if (Array.isArray(props.modelValue)) {
          const index = props.modelValue.findIndex((i) => i[props.itemValue] === item[props.itemValue]);
          return index !== -1;
        }
      }
    };
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
          return withDirectives((openBlock(), createElementBlock("div", {
            key: String(item[_ctx.itemValue]),
            class: normalizeClass(["inline-flex", { "*:px-0 *:py-0": _ctx.noPadding, grow: _ctx.grow }])
          }, [
            createVNode(_sfc_main$1, {
              size: _ctx.size,
              type: "secondary-outline-blue",
              disabled: item.disabled,
              icon: item.icon ? String(item.icon) : "",
              class: normalizeClass({
                "rounded-none": index !== 0 && index !== _ctx.items.length - 1 && _ctx.items.length > 1,
                "rounded-br-none rounded-tr-none": index === 0 && _ctx.items.length > 1,
                "rounded-bl-none rounded-tl-none": index === _ctx.items.length - 1 && _ctx.items.length > 1,
                "-mr-0.5": index !== _ctx.items.length - 1,
                "flex-1": _ctx.grow
              }),
              selected: isSelected(item) && _ctx.highlightSelected,
              onClick: ($event) => select(item)
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, `btn-${index}`, {
                  item,
                  isSelected: isSelected(item)
                }, () => [
                  createTextVNode(toDisplayString(item[_ctx.itemText]), 1)
                ])
              ]),
              _: 2
            }, 1032, ["size", "disabled", "icon", "class", "selected", "onClick"])
          ], 2)), [
            [_directive_tooltip, { content: tooltipText(item) }]
          ]);
        }), 128))
      ]);
    };
  }
});
export {
  _sfc_main as _
};
